import axios from "axios";
import dayjs from "dayjs";
import uuid from "react-uuid";
import {
  availableApi,
  fetchFAQApi,
  fetchPendingReasonsApi,
  fetchPoliciesApi,
  fetchPromotionsApi,
  fetchReviewRatingApi,
  fetchReviewRatingApi2,
  fetchSocialMediaPostsApi,
  getBNPLConfigApi,
  getLivePriceApi,
  getPaymentProviderApi,
  getTaxSlabsApi,
  isRoomAvailableApi,
  paymentApi,
  viewApi,
  getScriptTagIdApi,
} from "../../Services/mainPageService";
import toastr from "toastr";
import storageService from "../../Services/storageService";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import {
  convert24hrTo12hr,
  deviceType,
  generateRandomBinary,
  getLocationDetails,
  isDev,
  isStartTimeBeforeEndTime,
  sortRoomsByPriceAndAvailability,
} from "../../utils/utils";
import hotelInfoTypes from "../actionType/hotelInfoTypes";
import { useEffect } from "react";
import { priceCalculator } from "../../utils/calculator";

const sortRoomByPrice = (rooms) => {
  return rooms.sort((a, b) => {
    const sumA = a?.pricing.reduce((acc, val) => acc + val?.price, 0);
    const sumB = b?.pricing.reduce((acc, val) => acc + val?.price, 0);
    return sumA - sumB;
  });
};

function getLowestPriceWithAdultCount(rooms) {
  let lowestPrice = Infinity;
  let adultCountForLowestPrice = 0;
  let roomNameForLowestPrice = "";

  rooms.forEach((room) => {
    room?.pricing?.forEach((pricing) => {
      if (pricing.priceForPax) {
        pricing.priceForPax.forEach((pax) => {
          if (pax.priceBeforeTax < lowestPrice) {
            lowestPrice = pax.priceBeforeTax;
            adultCountForLowestPrice = pricing.adultCount || 1;
            roomNameForLowestPrice = room.roomName;
          }
        });
      } else if (pricing.price < lowestPrice) {
        lowestPrice = pricing.price;
        adultCountForLowestPrice = pricing.adultCount || 1;
        roomNameForLowestPrice = room.roomName;
      }
    });
  });

  return {
    lowestPrice: Math.round(lowestPrice),
    adultCount: adultCountForLowestPrice,
    roomName: roomNameForLowestPrice,
  };
}

export const available =
  (params, showLoader = true, ln = "en", shouldReset = true) =>
  async (dispatch) => {
    showLoader && dispatch({ type: hotelInfoTypes.FETCHING, payload: true });
    shouldReset && dispatch({ type: hotelInfoTypes.RESET, payload: true });

    if (dayjs(params?.checkOutDate).isBefore(dayjs(params?.checkInDate))) {
      toastr.error("Invalid Dates");
      window.location.href = `/rooms/${params?.id}/${dayjs().format(
        "YYYY-MM-DD"
      )}/${dayjs().add(1, "day").format("YYYY-MM-DD")}/2/0`;
    }

    const response = await availableApi(params, ln);

    let newRooms = [];

    if (response?.status === 200) {
      const { data = [] } = response;
      let testId =
        storageService.get("testId") === 0 || storageService.get("testId") === 1
          ? storageService.get("testId")
          : null;
      if (testId === null) {
        testId = Math.floor(Math.random() * 2);
        storageService.set("testId", 0);
      }
      let showBanner =
        storageService.get("showBanner") === 0 ||
        storageService.get("showBanner") === 1
          ? storageService.get("showBanner")
          : null;

      if (showBanner === null) {
        showBanner = Math.floor(Math.random() * 2);
        storageService.set("showBanner", showBanner);
      }

      const { checkInDate, checkOutDate } = params;
      storageService.set("hotelId", data[0]?.id);
      storageService.set("hotelName", data[0]?.name);
      storageService.set("slug", data[0]?.websiteSlug);
      storageService.set("domain", data[0]?.domain);
      storageService.set("isGHC", data[0]?.ghcEnabled);

      storageService.set("checkInDate", checkInDate);
      storageService.set("checkOutDate", checkOutDate);

      let hotelData = { ...data[0] };

      let { HotelRooms = [] } = hotelData;

      storageService.set("rooms", HotelRooms);

      HotelRooms = HotelRooms?.filter((rm) =>
        rm?.pricing?.every((pr) => pr?.price > 0)
      );

      const isVRHotel = storageService.get("source") === "google_vr";

      let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (timeZone === "Etc/Unknown") {
        timeZone = null;
      } else {
        timeZone = encodeURIComponent(timeZone);
      }
      let url = timeZone
        ? `${data[0]?.id}&checkInDate=${dayjs(checkInDate).format(
            "DD/MM/YYYY"
          )}&checkOutDate=${dayjs(checkOutDate).format(
            "DD/MM/YYYY"
          )}&shouldApplyFilter=true&timezone=${timeZone}`
        : `${data[0]?.id}&checkInDate=${dayjs(checkInDate).format(
            "DD/MM/YYYY"
          )}&checkOutDate=${dayjs(checkOutDate).format(
            "DD/MM/YYYY"
          )}&shouldApplyFilter=true`;

      const promotions = (await fetchPromotionsApi(url))?.data;

      console.log("idhoek", { promotions });

      console.log({ params });

      priceCalculator({
        checkInDate,
        checkOutDate,
        adultCount: +(params?.adultCount ?? params?.totalAdult ?? 2),
        childCount: +(
          params?.childCount ??
          params?.totalChild ??
          params?.totalChildren ??
          0
        ),
        hotelRooms: HotelRooms,
        infantCount: params?.infantCount,
        promotions,
      });

      if (isVRHotel) {
        HotelRooms = [
          HotelRooms?.reduce(
            (lowestRoom, room) =>
              !lowestRoom || +lowestRoom?.defaultPrice > +room?.defaultPrice
                ? room
                : lowestRoom,
            null
          ),
        ];
      }

      let hourlyTime = dayjs("2023/09/09")
        .add(1, "hour")
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
        .format("hh:mm A");

      let isHourly = HotelRooms?.some((rm) => rm?.hourly?.length > 0) || false;

      HotelRooms.forEach((room) => {
        let { HotelRoomAddons = [] } = room;
        HotelRoomAddons = HotelRoomAddons?.filter(
          (adn) => adn?.Addon?.category !== "person"
        );
        let obj = { ...room, HotelRoomAddons };
        newRooms.push(obj);
      });

      if (newRooms.length > 0) {
        let availRooms = newRooms?.filter((rm) =>
          rm?.pricing?.every((rv) => rv?.roomCount > 0)
        );

        let nonAvailRooms = newRooms?.filter((rm) =>
          rm?.pricing?.some((rv) => rv?.roomCount === 0)
        );

        const sortedAvbRooms = sortRoomByPrice(availRooms);
        const lowestAmount = getLowestPriceWithAdultCount(sortedAvbRooms);
        storageService.set("lowestAmount", lowestAmount);
        newRooms = [...sortedAvbRooms, ...nonAvailRooms];
        storageService.set("lowestRoom", availRooms?.[0] || {});
      }
      let isRatePlan = newRooms?.some((rm) => rm?.ratePlans);

      // if (isRatePlan) {
      //   newRooms = sortRoomsByPriceAndAvailability(HotelRooms);
      // }
      const utmObj = storageService.get("utmObj");

      const bookingNights = dayjs(checkOutDate).diff(checkInDate, "days");
      newRooms = newRooms?.map((room) => {
        const filteredRatePlans = {};

        Object.entries(room?.ratePlans || {}).forEach(([id, ratePlan]) => {
          const config = JSON.parse(ratePlan?.ratePlanConfig ?? "null");
          if (
            +(config?.minLengthOfStay ?? 0) <= bookingNights ||
            utmObj?.googleSource === "verification"
          ) {
            filteredRatePlans[id] = ratePlan;
          }
        });

        return { ...room, ratePlans: filteredRatePlans };
      });

      hotelData = { ...hotelData, HotelRooms: newRooms };

      const taxResp = await getTaxSlabsApi(hotelData?.id);
      if (taxResp?.status === 200) {
        dispatch({ type: hotelInfoTypes.SET_TAXES, payload: taxResp?.data });
      }

      dispatch({ type: hotelInfoTypes.SET_IS_RATEPLAN, payload: isRatePlan });
      dispatch({ type: hotelInfoTypes.SHOW_HOURLY, payload: isHourly });
      dispatch({ type: hotelInfoTypes.DETAILS, payload: hotelData });
      const isNoInventry = newRooms?.every((rm) => !rm?.availableRooms);
      dispatch({
        type: hotelInfoTypes.SET_NOTIFY_NO_INVENTORY,
        payload: isNoInventry,
      });
      if (isNoInventry) {
        fireGtmEvent("No Inventry Found", { ...params });
      }
    } else if (
      response?.status === 400 &&
      response?.message?.includes("date")
    ) {
      window.location.href = `/rooms/${params?.id}/${dayjs().format(
        "YYYY-MM-DD"
      )}/${dayjs().add(1, "day").format("YYYY-MM-DD")}/2/0`;
    } else {
      let source = storageService.get("source") || "no_source";
      let utmObj = storageService.get("utmObj") || { utmSource: source };
      fireGtmEvent("availableApiFailed", { ...params, utmObj });
      window.location.href = "/pagenotfound";
    }
    dispatch({ type: hotelInfoTypes.FETCHING, payload: false });

    if (response?.status === 200) {
      let uuids = localStorage.getItem("uuid") || "";
      if (!uuids?.length > 0) {
        uuids = uuid();
        localStorage.setItem("uuid", uuids);
      }

      const { data = [] } = response;

      // const ipAdress = storageService.get("ipAdress");
      // if (!ipAdress) {
      try {
        const locationResp = await axios.get("https://ipapi.co/json/");

        let locationDetails = {};

        if (locationResp.status === 200) {
          locationDetails = { ...locationDetails, ...locationResp.data };
          storageService.set("ipAdress", locationDetails?.ip);
          storageService.set("city", locationDetails?.city);
          storageService.set("state", locationDetails?.region);
          storageService.set("country", locationDetails?.country_name);
          storageService.set("country_code", locationDetails?.country);
          storageService.set("dialcode", locationDetails?.country_calling_code);
        }
        storageService.set("locationDetails", locationDetails);
      } catch (error) {
        console.log("IP api failed!", error);
      }
      // }
    }
  };

export const fetchReview = (placeId, hotelID) => async (dispatch) => {
  const res = await fetchReviewRatingApi(placeId);
  const newres = await fetchReviewRatingApi2(hotelID);

  if (res?.status === 200 && newres.status === 200) {
    dispatch({ type: hotelInfoTypes.FETCH_REVIEW, payload: res?.data?.result });
    dispatch({
      type: hotelInfoTypes.FETCH_REVIEW_Arjun,
      payload: newres?.data,
    });
  }
};

export const addRatePlan =
  (obj, obj2, idx = 0, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: hotelInfoTypes.SELECT_RP, payload: obj });
    } catch (error) {
      fireGtmEvent("checkRoomApiFailed", obj);
    } finally {
      callback();
    }
  };
{
}

export const updateRatePlan = (payload) => async (dispatch) => {
  try {
    dispatch({ type: hotelInfoTypes.UPDATE_RP, payload });
  } catch (error) {
    console.log("Updating rate plan failed", error);
  }
};

export const removeRatePlan =
  (rpId, callback = {}) =>
  (dispatch) => {
    try {
      dispatch({ type: hotelInfoTypes.REMOVE_RP, payload: rpId });
    } catch (error) {
      console.log("Removing rate plan failed", error);
    } finally {
      callback();
    }
  };

export const addRoom = (room) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.SELECT_ROOM, payload: room });
};

export const deselectRoom = (room) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.DESELECT_ROOM, payload: room });
};

export const addAddon = (addon) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.SELECT_ADDON, payload: addon });
};

export const deselectAddon = (addon) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.DESELECT_ADDON, payload: addon });
};

export const addReview = (review) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.ADD_REVIEW, payload: review });
};

export const addRating = (rating) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.ADD_RATING, payload: rating });
};

export const addHotelAddon = (addon) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.ADD_HOTELADDON, payload: addon });
};

export const removeHotelAddon = (addon) => (dispatch) => {
  dispatch({ type: hotelInfoTypes.REMOVE_HOTELADDON, payload: addon });
};

export const fetchPendingReasons = () => async (dispatch) => {
  // dispatch({ type: hotelInfoTypes.FETCHING, payload: true });

  const response = await fetchPendingReasonsApi();

  if (response.status === 200) {
    dispatch({ type: hotelInfoTypes.PENDING_REASONS, payload: response.data });
  }

  // dispatch({ type: hotelInfoTypes.FETCHING, payload: false });
};

export const fetchSocialMediaPosts = (userName) => async (dispatch) => {
  const response = await fetchSocialMediaPostsApi(userName);

  if (response.status === 200) {
    dispatch({ type: hotelInfoTypes.SET_INSTA_LINKS, payload: response.data });
  }
};

export const fetchPromotions =
  (url, id = 0) =>
  async (dispatch) => {
    const response = await fetchPromotionsApi(url);
    if (response.status === 200) {
      dispatch({
        type: hotelInfoTypes.SET_PROMOTION,
        payload: response?.data?.filter((ar) => ar?.type !== "coupon"),
      });
      let promotionSelected = {};
      let multiplier = 1;
      if (response?.data?.length > 0) {
        const { data } = response;
        let arr = [...data];
        arr = arr.filter((ar) => ar?.type !== "coupon");
        arr.sort((b, a) => a.discount - b.discount);
        promotionSelected = arr[0];
        if (promotionSelected?.type !== "bulk") {
          multiplier = promotionSelected?.discount / 100;
        }
      }
      let source = storageService.get("source") || "Hotelzify_Fallback";
      let utmObj = storageService.get("utmObj") || { utmSource: source };
      let testId = 0;
      let showBanner = storageService.get("showBanner") || null;
      let sourceTrack = JSON.parse(localStorage.getItem("visited")) || [];
      let isGHC = storageService.get("isGHC");
      let locat = new URLSearchParams(new URL(window.location.href).search);
      let searchParams = Object.fromEntries(locat);
      let uuids = storageService.get("uuid");
      let locationDetails = storageService.get("locationDetails");
      let HotelRooms = storageService.get("lowestRoom") || {};
      let checkInDate = storageService.get("checkInDate");
      let checkOutDate = storageService.get("checkOutDate");
      searchParams = {
        ...searchParams,
        shownPrice: HotelRooms?.pricing?.[0]?.price,
        promotionSelected,
        discountPrice:
          HotelRooms?.pricing?.[0]?.price -
          HotelRooms?.pricing?.[0]?.price * multiplier,
      };
      storageService.set("searchParams", searchParams);

      let rooms = storageService.get("rooms") || [];

      let obj = {
        source,
        deviceType,
        locationDetails,
        testId,
        isGHC,
        isDev: isDev,
        showBanner,
        networkSpeed: window?.navigator?.connection?.effectiveType || "not-set",
        uuid: uuids,
        searchParams,
        checkInDate,
        checkOutDate,
        isAvailable: rooms?.some((rm) => rm?.availableRooms > 0),
        date: dayjs().format("DD-MM-YYYY hh:mm"),
        ...utmObj,
      };
      sourceTrack = [...sourceTrack, { ...obj, hotelId: id }];
      localStorage.setItem("visited", JSON.stringify(sourceTrack));
    }
  };

export const fetchFAQ = (id) => async (dispatch) => {
  const response = await fetchFAQApi(id);
  if (response.status === 200) {
    dispatch({ type: hotelInfoTypes.GET_FAQ, payload: response.data });
  }
};

export const fetchPolicy =
  (id, ln = "en") =>
  async (dispatch) => {
    const response = await fetchPoliciesApi(id, ln);
    if (response.status === 200) {
      dispatch({ type: hotelInfoTypes.GET_POLICY, payload: response.data });
    }
    // dispatch({ type: hotelInfoTypes.FETCHING, payload: false });
  };

export const fetchPayment = (obj) => async (dispatch) => {
  const response = await paymentApi(obj);
  if (response.status === 200) {
    dispatch({ type: hotelInfoTypes.SET_PAYMENTS, payload: response.data });
  }
};

export const getLivePrice = (obj) => async (dispatch) => {
  const response = await getLivePriceApi(obj);
  if (response?.status === 200) {
    dispatch({ type: hotelInfoTypes.SET_LIVE_PRICE, payload: response?.data });
  }
};

export const fetchPaymentProvider = (id) => async (dispatch) => {
  const response = await getPaymentProviderApi(id);
  if (response?.status === 200) {
    dispatch({
      type: hotelInfoTypes.SET_PAYMENT_PROVIDER,
      payload: response?.data,
    });
  }
};

export const fetchBNPLConfig = (hotelId) => async (dispatch) => {
  const response = await getBNPLConfigApi(hotelId);

  if (response.status === 200) {
    dispatch({ type: hotelInfoTypes.BNPL_CONFIG, payload: response.data });
  }
};

//for scripttag
export const fetchScriptTagId = (hotelId) => async (dispatch) => {
  const response = await getScriptTagIdApi(hotelId);

  if (response.status === 200) {
    dispatch({
      type: hotelInfoTypes.GET_SCRIPT_TAG_ID,
      payload: response.data.scriptTagID,
    });
  }
};
